import { render, staticRenderFns } from "./ActionPanelBlock.vue?vue&type=template&id=071e9fd0&scoped=true&"
import script from "./ActionPanelBlock.vue?vue&type=script&lang=js&"
export * from "./ActionPanelBlock.vue?vue&type=script&lang=js&"
import style0 from "./ActionPanelBlock.vue?vue&type=style&index=0&id=071e9fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071e9fd0",
  null
  
)

export default component.exports